// src/utils/injectArticleCss.ts
export const injectArticleCss = () => {
  if (document.getElementById('shareable-article-css')) return;

  const style = document.createElement('style');
  style.id = 'shareable-article-css';

  style.innerHTML = `
    /* Scope everything */
    .shareable-article-html {
      max-width: 100%;
      box-sizing: border-box;
      word-break: break-word;
      overflow-wrap: anywhere;
      font-size: 16px;
      line-height: 1.6;
    }

    /* Images */
    .shareable-article-html img {
      max-width: 100%;
      height: auto;
      display: block;
    }

    /* Tables */
    .shareable-article-html table {
      display: inline;
      table-layout: fixed;
      width: 100%;
      max-width: 100%;
      word-break: break-word;
      min-width: 0 !important;
    }

    .shareable-article-html th,
    .shareable-article-html td {
      padding: 8px;
      word-break: break-word;
    }

    /* Iframes / embeds */
    .shareable-article-html iframe,
    .shareable-article-html video {
      max-width: 100%;
    }

    /* Headings scale */
    .shareable-article-html h1 { font-size: 1.6em; }
    .shareable-article-html h2 { font-size: 1.4em; }
    .shareable-article-html h3 { font-size: 1.2em; }

    /* Lists */
    .shareable-article-html ul,
    .shareable-article-html ol {
      padding-inline-start: 20px;
    }

    /* Prevent layout breaking */
    .shareable-article-html * {
      box-sizing: border-box;
      max-width: 100%;
    }

    /* Mobile tuning */
    @media (max-width: 768px) {
      .shareable-article-html {
        font-size: 14px;
      }
    }
  `;

  document.head.appendChild(style);
};
